<template>
  <div class="column">
    <div class="mrs mbm flex-container">
      <span class="text-left medium-6">
        Sie sehen sich {{ count }} Projekte an.
      </span>
      <div class="text-right medium-6">
        <span class="mls">
          <a :disabled="!enabled" @click="removeAllCompleted">
            Alle abgeschlossenen entfernen
          </a>
          <span> |</span>
          <a :disabled="!enabled" @click="clearFilters">
            Filter löschen
          </a>
        </span>
      </div>
    </div>
    <div class="flex-container align-middle mbm">
      <label for="filters">Filter:</label>
      
      <select v-model="status" class="mbn mls mrs">
        <option
          v-for="(option, index) in briefOptions"
          :key="index"
          :value="option.value"
          :disabled="!enabled"
          class="mls mrs">
          {{ option.label }}
        </option>
      </select>
      
      <select v-model="daysLeft" class="mbn mls">
        <option
          v-for="(option, index) in dayOptions"
          :key="index"
          :value="option.value"
          :disabled="!enabled"
          class="mls mrs">
          {{ option.label }}
        </option>
      </select>
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      status: null,
      daysLeft: null,
      briefOptions: [
        {
          label: `Kurzstatus filtern`,
          value: null,
        },
        {
          label: `offene`,
          isSelected: false,
          value: 'Open',
        },
        {
          label: `Entscheidung`,
          value: 'Deciding',
        },
        {
          label: `Abgeschlossen`,
          value: 'Closed',
        },
      ],
      dayOptions: [
        {
          label: `Filtern Sie nach verbleibenden Tagen`,
          value: null,
        },
        {
          label: `Weniger als 1 Tag`,
          value: '1',
        },
        {
          label: `Weniger als 3 Tage`,
          value: '3',
        },
        {
          label: `Weniger als 7 Tage`,
          value: '7',
        },
        {
          label: `Weniger als 10 Tage`,
          value: '10',
        },
        {
          label: `Weniger als 15 Tage`,
          value: '15',
        },
      ],
    };
  },
  watch: {
    async status(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
    async daysLeft(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
  },
  methods: {
    async update() {
      if (!this.enabled) {
        return;
      }
      this.$emit('filter-update', {
        status: this.status,
        daysLeft: this.daysLeft,
      });
    },
    removeAllCompleted() {
      this.$emit('remove-all-completed');
    },
    clearFilters() {
      this.status = null;
      this.daysLeft = null;
      this.update();
    },
  },
};
</script>
